"use client";
import React from "react";
import Image from "next/image";
import useOnScreen from "@/src/hooks/useOnScreen";

import { AnimatedGalleryProps } from "./types";
import { getTranslateClass } from "@/src/constants/animations";

const AnimatedGallery: React.FC<AnimatedGalleryProps> = ({
  images,
  direction = "left",
}) => {
  return (
    <div className="grid grid-cols-2 gap-4 w-full md:w-1/2 mt-4 md:mt-0">
      {images.map((image, index) => (
        <AnimatedGalleryItem
          key={index}
          src={image.url}
          alt={image.title || `Image ${index + 1}`}
          direction={
            direction === "alternate"
              ? index % 2 === 0
                ? "left"
                : "right"
              : direction
          }
        />
      ))}
    </div>
  );
};

const AnimatedGalleryItem: React.FC<{
  src: string;
  alt: string;
  direction: "left" | "right" | "top" | "bottom";
}> = ({ src, alt, direction }) => {
  const { ref, isIntersecting } = useOnScreen<HTMLDivElement>(0.1, true);

  return (
    <div
      ref={ref}
      className={`transition-transform duration-700 ease-in-out ${
        isIntersecting
          ? "translate-x-0 translate-y-0 opacity-100"
          : `${getTranslateClass(direction)} opacity-0`
      }`}
    >
      <Image
        src={src}
        alt={alt}
        width={354}
        height={220}
        className="rounded-md object-cover"
      />
    </div>
  );
};

export default AnimatedGallery;
